import React, { Component, Fragment } from 'react';
import { Button, message, Modal } from 'antd';
import { ITEMSCLASSES, EXTRASPARAMS } from '../../utils/items';
import { isEmpty, result } from 'lodash';
import './style.css';
import './modalStyle.css';

export default class NgGameRPGArenaUiCave extends Component {

    state = {
        selectedExtraItem: null, // это индекс от нуля в линейке экстра
        selectedExtraIdInChest: null, // это какой id предмета выбран,
        caveUi: 'flag'
    }

    setCaveUi = (caveUi) => this.setState({ caveUi })

    trFontSizeSelector = (trFontSize) => {
        switch (trFontSize) {
            case '1': return this.props.width * 0.0412;
            case '2': return this.props.width * 0.0206;
            case '3': return this.props.width * 0.011126;
            case '4': return this.props.width * 0.017;
            case '5': return this.props.width * 0.014;
            default: return 1;
        }
    }

    trMarginSelector = (trMargin) => {
        switch (trMargin) {
            case '1': return this.props.width * 0.1;
            case '2': return this.props.width * 0.05;
            default: return 1;
        }
    }

    trRelateSize = (maketWidth) => this.props.width * (maketWidth / 1000);

    selectExtraItem = (selectedExtraItem) => {

        let selectedExtraIdInChest = null;
        if (selectedExtraItem !== null) {
            const { caveSession: { person: { extras, items } } } = this.props;
            const extraSelectedInBar = extras[selectedExtraItem] || {};
            let selectedItemInBar = items.find(x => x.id === extraSelectedInBar.id); // какой id у предмета в ячейке, на которую мы нажали
            if (selectedItemInBar) selectedExtraIdInChest = selectedItemInBar.id;
        }

        this.setState({ selectedExtraItem, selectedExtraIdInChest })
    }
    selectExtraIdInChest = (selectedExtraIdInChest) => this.setState({ selectedExtraIdInChest })

    setNewExtras = (command, item) => {

        const { caveSession: { person: { extras, items } } } = this.props;
        const { selectedExtraItem } = this.state;
        const extraSelectedInBar = extras[selectedExtraItem] || null;

        let hand = [];

        if (command === 'add') {
            // нам надо понять - тот айтем, что мы выбрали, он уже есть в эстрах в другой ячейке или нет
            const allreadyInExtras = extras.find(x => x.id === item.id);

            // Это значит, мы добавляем БЕЛУЮ ячейку из сундука
            if (allreadyInExtras) {
                // есть в другой ячейке

                // если мы тыкали не в пустоту, то мы будем менять местами
                if (extraSelectedInBar && extraSelectedInBar.type !== 'empty') {
                    for (let i = 0; i < extras.length; i++) {
                        const extra = extras[i];
                        const { type, id } = extra;
                        if (type === 'empty') continue;

                        if (id === extraSelectedInBar.id) {
                            hand.push(item.id);
                            continue;
                        }

                        if (id === item.id) {
                            hand.push(extraSelectedInBar.id);
                            continue;
                        }

                        hand.push(id);
                    }
                } else {
                    // если мы тыкали в пустоту, то убираем по дороге, добавляем в конец
                    for (let i = 0; i < extras.length; i++) {
                        const extra = extras[i];
                        const { type, id } = extra;
                        if (type === 'empty') continue;
                        if (id === item.id) {
                            continue;
                        }
                        hand.push(id);
                    }
                    hand.push(item.id);
                }
            } else {
                // мы тыкали не в ПУСТО, нужно заменить
                if (extraSelectedInBar && extraSelectedInBar.type !== 'empty') {
                    for (let i = 0; i < extras.length; i++) {
                        const extra = extras[i];
                        const { type, id } = extra;
                        if (type === 'empty') continue;
                        if (id === extraSelectedInBar.id) {
                            hand.push(item.id);
                            continue;
                        }
                        hand.push(id);
                    }
                } else {
                    // если мы тыкали в пустоту, то тупо
                    for (let i = 0; i < extras.length; i++) {
                        const extra = extras[i];
                        const { type, id } = extra;
                        if (type === 'empty') continue;
                        hand.push(id);
                    }
                    hand.push(item.id);
                }
            }

        }
        if (command === 'delete') {
            for (let i = 0; i < extras.length; i++) {
                const extra = extras[i];
                const { type, id } = extra;
                if (type === 'empty') continue;

                if (id === item.id) {
                    continue;
                }

                hand.push(id);
            }
        }

        this.selectExtraItem(null);
        this.props.setPlayerExtras(hand);
    }

    render() {

        const { CaveScreen, EndBlockScreen, ChoosedBlockModal } = this;

        const { width, height, arena, phase } = this.props;
        const { arenaWidth, arenaHeight } = arena;

        if (phase === 'endCaveScreen') {
            return <div className='ngg_caveui_container' style={{ width: arenaWidth, height: arenaHeight }}>
                <EndBlockScreen />
            </div>
        }

        if (phase === 'cavescreen')
            return <div className='ngg_caveui_container' style={{ width: arenaWidth, height: arenaHeight }}>
                <ChoosedBlockModal />
                <CaveScreen />
            </div>

        return null;
    }

    CaveScreen = () => {
        const { CaveText, ExtrasItems, CaveUi } = this;
        const { width, height, caveSession } = this.props;
        const { cave } = caveSession;
        const { label } = cave;

        const { selectedExtraItem } = this.state;
        let inner = null;

        // это значит предметы показываем
        if (selectedExtraItem !== null) {
            inner = <ExtrasItems style={{ left: width * 0.025, top: height * 0.05, width: width * 0.95, height: height * 0.9, borderRadius: width * 0.025, zIndex: 3 }} />
        }

        // это НЕ предметы значит
        if (!inner) {
            const { CaveScreenByUi } = this;
            inner = <Fragment>
                <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(13.65), left: this.trMarginSelector('1') }} >ПЕЩЕРА</CaveText>
                <CaveText trFontSize='1' absolute style={{ top: this.trRelateSize(38.55), left: this.trMarginSelector('2') }} >{label}</CaveText>
                <CaveScreenByUi />
                <CaveUi />
            </Fragment>
        }

        return <div className='ngg_caveui_main' style={{ width, height, borderRadius: width * 0.025 }}>
            <img className='ngg_caveui_main_bg' src='/../images/ver2/snowman/ui/background_1.jpg' style={{ width: width, height, zIndex: 1, borderRadius: width * 0.025 }} />
            <div className='ngg_caveui_main_container' style={{ width, height, borderRadius: width * 0.025, zIndex: 2 }}>
                {inner}
            </div>
        </div>
    }

    get flagsLeft() {

        const { caveSession } = this.props;
        const { cave, props } = caveSession;

        const {
            tryes,
            deathPenalty
        } = cave;

        const flagsAll = tryes;
        let flagsLeft = flagsAll;

        const { history = [] } = props;
        flagsLeft -= history.length;

        const deaths = history.filter(x => !x.playerWon);
        flagsLeft -= deaths.length * deathPenalty;

        return { flagsAll, flagsLeft };
    }

    PassedFlags = ({ style }) => {
        // const { playerWon, statistics } = lastHistory;
        const { flagsAll, flagsLeft } = this.flagsLeft;
        const flags = [];

        for (let i = 0; i < flagsAll; i++) {
            if (i < flagsLeft) {
                flags.push(
                    <img id={`flag_${i}`} src={`/../images/ver2/snowman/ui/flag_clean.png`} />
                )
            } else {
                flags.push(
                    <img id={`flag_${i}`} src={`/../images/ver2/snowman/ui/flag_full.png`} />
                )
            }
        }


        return <div className='ngg_caveui_main_passedflags' style={style}>
            {flags}
        </div>
    }

    CaveScreenByUi = () => {
        const { caveUi = 'flag' } = this.state;
        const { width } = this.props;
        const { CaveText, Structure, PassedFlags, ExtrasCave, PersonStats } = this;
        if (caveUi === 'flag') {
            return <Fragment>
                {/* разница - 24,9 */}

                <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(94.3), left: this.trMarginSelector('1') }} >КОМНАТЫ</CaveText>
                <PassedFlags style={{
                    top: this.trRelateSize(89.3), left: this.trMarginSelector('1') + this.trRelateSize(105.3), height: this.trRelateSize(24)
                }} />
                <Structure style={{
                    top: this.trRelateSize(119.2), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(192),
                    borderRadius: this.trRelateSize(20)

                }} />

                <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(325.71), left: this.trMarginSelector('1') }} >ВАШИ ЭКСТРА</CaveText>
                <ExtrasCave style={{
                    top: this.trRelateSize(325.71 + 24, 9), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(133),
                    borderRadius: this.trRelateSize(20)

                }} />

                <div className='ngg_caveui_main_mbutton' style={{
                    top: this.trRelateSize(520), left: this.trMarginSelector('2') + width * 0.15, width: width * 0.6, height: this.trRelateSize(50),
                    borderRadius: this.trRelateSize(7),
                    fontSize: this.trFontSizeSelector('2'),
                    background:
                        this.props.caveSession.props.isPassed ?
                            'rgb(44, 138, 0)'
                            :
                            'rgb(97, 0, 0)'
                }}
                    onClick={() => {

                        if (this.props.caveSession.props.isPassed || this.flagsLeft.flagsLeft <= 0) {
                            this.props.abandoneCave()
                        } else
                            Modal.warning({
                                className: 'event_participation_decline_modal',
                                title: 'Покинуть пещеру?',
                                content: 'Вы уверены, что хотите покинуть пещеру?',
                                onOk: this.props.abandoneCave,
                                onCancel: () => { },
                                okText: 'ПОКИНУТЬ',
                                cancelText: 'ОСТАТЬСЯ',
                                okCancel: true,
                                closable: true,
                                centered: true
                            })


                    }}

                >
                    <span>ПОКИНУТЬ ПЕЩЕРУ</span>
                </div>
            </Fragment >
        }
        if (caveUi === 'person') {
            return <Fragment>
                {/* разница - 24,9 */}

                <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(94.3), left: this.trMarginSelector('1') }} >СТАТЫ</CaveText>
                <PersonStats style={{
                    top: this.trRelateSize(119.2), left: this.trMarginSelector('2'), width: this.trRelateSize(260), height: this.trRelateSize(330),
                    borderRadius: this.trRelateSize(20)
                }} />

                {/* <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(325.71), left: this.trMarginSelector('1') }} >ВАШИ ЭКСТРА</CaveText>
                <ExtrasCave style={{
                    top: this.trRelateSize(325.71 + 24, 9), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(133, 32),
                    borderRadius: this.trRelateSize(20)

                }} /> */}
            </Fragment>
        }

        return null;

    }

    PersonStats = ({ style }) => {
        const { CaveText } = this;
        const { caveSession } = this.props;
        const { person, props, methods } = caveSession;
        const { lvl, innerLvl, force, innerLives, exp, extrasSlots } = person;
        let NowHP = props.NowHP;
        if (!NowHP) NowHP = innerLives;

        const marginLeft1 = this.trRelateSize(20);
        const marginLeft2 = this.trRelateSize(238);
        const top = this.trRelateSize(30);
        const marginHeight = this.trRelateSize(30);

        const { now, needed } = methods.scoresLvlByTypeRework(exp || 1);

        const notMyLvl = lvl !== innerLvl;

        const stats = [
            { name: notMyLvl ? 'УРОВЕНЬ СНИЖЕН' : 'УРОВЕНЬ', value: notMyLvl ? `${lvl}/(${innerLvl})` : `${innerLvl}` },
            { name: 'ОПЫТ', value: `${now}/${needed}` },
            { name: 'ЗДОРОВЬЕ', value: `${Math.floor(NowHP * 10) / 10}/${innerLives}` },
            { name: 'СИЛА', value: `${force}` },
            { name: 'СЛОТЫ ЭКСТРА', value: `${extrasSlots}` }
        ]

        return <div className='ngg_caveui_main_structure' style={style}>
            {stats.map(({ name, value }, index) => <Fragment>
                <CaveText trFontSize='4' absolute style={{ top: top + (index * marginHeight), left: marginLeft1 }} >{name}</CaveText>
                <CaveText trFontSize='4' className={'ngg_caveui_text_right'} absolute style={{ top: top + (index * marginHeight), left: marginLeft2 }} >{value}</CaveText>
            </Fragment>)}
        </div>
    }

    CaveUi = () => {
        const { caveUi = 'flag' } = this.state;

        const { caveSession } = this.props;
        const { person, props } = caveSession;
        const { innerLives } = person;
        let NowHP = props.NowHP;
        if (!NowHP) NowHP = innerLives;

        const top = this.trRelateSize(13.65)
        const left = this.trRelateSize(648.4)
        const margin = this.trRelateSize(16.36)
        const buttonWidth = this.trRelateSize(88.67)

        const hpTop = buttonWidth * 0.91;
        const hpHeight = this.trRelateSize(5);
        const hpWidth = buttonWidth * 0.8;
        const hpLeft = buttonWidth * 0.1;
        const hpBorder = this.trRelateSize(1.2);

        const hpWidthReal = hpWidth * (NowHP / innerLives);

        const downHpStyle = {
            top: hpTop,
            left: hpLeft,
            borderRadius: hpBorder,
            height: hpHeight,
            width: hpWidth
        }

        const upHpStyle = {
            top: hpTop,
            left: hpLeft,
            borderRadius: hpBorder,
            height: hpHeight,
            width: hpWidthReal
        }

        return <Fragment>
            <div className='ngg_caveui_button'
                onClick={() => this.setCaveUi('flag')}
                style={{ width: buttonWidth, height: buttonWidth, top, left: left + 0 * (buttonWidth + margin), borderRadius: buttonWidth * 0.09 }}>
                <img src={`/../images/ver2/snowman/ui/flag_${caveUi === 'flag' ? 'up' : 'down'}.jpg`} />
            </div>
            <div
                onClick={() => this.setCaveUi('cave')}
                className='ngg_caveui_button' style={{ width: buttonWidth, height: buttonWidth, top, left: left + 1 * (buttonWidth + margin), borderRadius: buttonWidth * 0.09 }}>
                <img src={`/../images/ver2/snowman/ui/cave_${caveUi === 'cave' ? 'up' : 'down'}.jpg`} />
            </div>
            <div
                onClick={() => this.setCaveUi('person')}
                className='ngg_caveui_button' style={{ width: buttonWidth, height: buttonWidth, top, left: left + 2 * (buttonWidth + margin), borderRadius: buttonWidth * 0.09 }}>
                <img src={`/../images/ver2/snowman/ui/person_${caveUi === 'person' ? 'up' : 'down'}.jpg`} />
                <div className='ngg_caveui_button_hp_down' style={downHpStyle}></div>
                <div className='ngg_caveui_button_hp_up' style={upHpStyle}></div>
            </div>

        </Fragment>

    }

    // экран окончания блока
    EndBlockScreen = () => {

        const { CaveText, CaveEndAchivs, Lut } = this;
        const { width, height, caveSession } = this.props;
        const { props } = caveSession;

        // сбрасываем блок и вперёд
        const onNextClick = () => {
            this.chooseBlock();
            this.props.onNextClick();
        }

        const { history } = props;
        const lastHistory = history[history.length - 1];
        const { playerWon, statistics } = lastHistory;

        if (playerWon)

            return <div className='ngg_caveui_main' style={{ width, height, borderRadius: width * 0.025 }}>
                <img className='ngg_caveui_main_bg' src='/../images/ver2/snowman/ui/background_1.jpg' style={{ width: width, height, zIndex: 1, borderRadius: width * 0.025 }} />
                <div className='ngg_caveui_main_container' style={{ width, height, borderRadius: width * 0.025, zIndex: 2 }}>
                    <CaveText trFontSize='1' absolute style={{ top: this.trRelateSize(38.55), left: this.trMarginSelector('2') }} >ПОБЕДА</CaveText>
                    {/* разница - 24,9 */}

                    <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(94.3), left: this.trMarginSelector('1') }} >СТАТИСТИКА ПРОХОЖДЕНИЯ</CaveText>
                    <CaveEndAchivs style={{
                        top: this.trRelateSize(119.2), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(192),
                        borderRadius: this.trRelateSize(20)

                    }} />

                    <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(325.71), left: this.trMarginSelector('1') }} >ЛУТ</CaveText>
                    <Lut style={{
                        top: this.trRelateSize(325.71 + 24, 9), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(133, 32),
                        borderRadius: this.trRelateSize(20)

                    }} />

                    <div className='ngg_caveui_main_mbutton' style={{
                        top: this.trRelateSize(520), left: this.trMarginSelector('2') + width * 0.15, width: width * 0.6, height: this.trRelateSize(50),
                        borderRadius: this.trRelateSize(7),
                        fontSize: this.trFontSizeSelector('2'),
                        background: 'rgb(44, 138, 0)'
                    }}
                        onClick={onNextClick}

                    >
                        <span>ДАЛЕЕ</span>
                    </div>
                </div>
            </div>

        return <div className='ngg_caveui_main' style={{ width, height, borderRadius: width * 0.025 }}>
            <img className='ngg_caveui_main_bg' src='/../images/ver2/snowman/ui/background_1.jpg' style={{ width: width, height, zIndex: 1, borderRadius: width * 0.025 }} />
            <div className='ngg_caveui_main_container' style={{ width, height, borderRadius: width * 0.025, zIndex: 2 }}>
                <CaveText trFontSize='1' absolute style={{ top: this.trRelateSize(38.55), left: this.trMarginSelector('2') }} >ПОРАЖЕНИЕ</CaveText>
                <CaveText trFontSize='2' absolute style={{ top: this.trRelateSize(94.3), left: this.trMarginSelector('1') }} >СТАТИСТИКА ПРОХОЖДЕНИЯ</CaveText>
                <CaveEndAchivs style={{
                    top: this.trRelateSize(119.2), left: this.trMarginSelector('2'), width: width * 0.9, height: this.trRelateSize(192),
                    borderRadius: this.trRelateSize(20)

                }} />
                <div className='ngg_caveui_main_mbutton' style={{
                    top: this.trRelateSize(520), left: this.trMarginSelector('2') + width * 0.15, width: width * 0.6, height: this.trRelateSize(50),
                    borderRadius: this.trRelateSize(7),
                    fontSize: this.trFontSizeSelector('2'),
                    background: 'rgb(97, 0, 0)'
                }}
                    onClick={onNextClick}

                >
                    <span>ДАЛЕЕ</span>
                </div>
            </div>
        </div>

        // <div className='ngg_caveui_main' style={{ width, height }}>
        //     {/* <CaveH1>{playerWon ? 'ПОБЕДА' : 'ПОРАЖЕНИЕ'}</CaveH1> */}
        //     {!!statistics.technics && `Техник использовано: ${Object.keys(statistics.technics).length}`}
        //     <div className='ngg_caveui_main_nextbutton' onClick={onNextClick} style={{ width: width * 0.7, height: width * 0.3 }}>
        //         <span>
        //             ДАЛЕЕ
        //         </span>
        //     </div>
        // </div>
    }

    CaveText = ({ children, trFontSize, style = {}, className, absolute, onClick = () => { } }) => <div onClick={onClick} className={'ngg_cave_text_sms ' + (absolute ? 'ngg_cave_text_sms_absolute' : '') + ' ' + className} style={{ fontSize: `${this.trFontSizeSelector(trFontSize)}px`, lineHeight: `${this.trFontSizeSelector(trFontSize) * 0.8}px`, ...style }}>{children}</div>

    // это где рисуются комнатки
    Structure = ({ style }) => {
        const { CaveText } = this;
        const { caveSession } = this.props;
        const { cave, props: { isPassed } } = caveSession;
        const { blockStructure } = cave;

        const blocks = Object.values(blockStructure);

        const { flagsLeft } = this.flagsLeft;

        if (isPassed) {
            return <div className='ngg_caveui_main_structure' style={style}>
                <CaveText trFontSize='2' >ПЕЩЕРА ПРОЙДЕНА</CaveText>
            </div>
        }

        if (flagsLeft <= 0) {
            return <div className='ngg_caveui_main_structure' style={style}>
                <CaveText trFontSize='2' >У ВАС ЗАКОНЧИЛИСЬ ПРОХОЖДЕНИЯ</CaveText>
            </div>
        }

        return <div className='ngg_caveui_main_structure' style={style}>
            {blocks.map((block) => <this.OneBlock block={block} />)}
        </div>
    }

    // это плашечка в конце комнаты
    CaveEndAchivs = ({ style }) => {
        const { caveSession } = this.props;
        const { cave, props } = caveSession;

        const { history } = props;
        const lastHistory = history[history.length - 1];
        const { statistics } = lastHistory;

        const { startBlockTime, endBlockTime, snowmanHit, playerHit } = statistics;

        let allStatsBlock = []; // {text, value}
        let allStatsCave = []; // {text, value}

        let allTimeInCave = 0;
        let allTimeInBlock = 0;

        let allSnowmanHit = 0;
        let allPlayerHit = 0;

        let allDeaths = 0;

        if (startBlockTime && endBlockTime) {
            allTimeInBlock = endBlockTime - startBlockTime;
        }

        for (let i = 0; i < history.length; i++) {
            const { playerWon } = history[i];
            const { startBlockTime, endBlockTime, snowmanHit, playerHit } = history[i].statistics;
            if (startBlockTime && endBlockTime) {
                allTimeInCave += endBlockTime - startBlockTime;
            }
            if (!playerWon) {
                allDeaths++;
            }
            if (snowmanHit !== undefined && snowmanHit !== null) allSnowmanHit += snowmanHit;
            if (playerHit !== undefined && playerHit !== null) allPlayerHit += playerHit;
        }

        if (allTimeInBlock) allStatsBlock.push({ text: 'Время / В комнате:', value: new Date(allTimeInBlock).toISOString().slice(14, 19) })
        if (allTimeInCave) allStatsCave.push({ text: 'Всего:', value: new Date(allTimeInCave).toISOString().slice(14, 19) })

        allStatsBlock.push({ text: 'Ударов нанесено', value: playerHit })
        allStatsCave.push({ text: 'Всего:', value: allPlayerHit })

        allStatsBlock.push({ text: 'Ударов пропущено', value: snowmanHit })
        allStatsCave.push({ text: 'Всего:', value: allSnowmanHit })

        allStatsCave.push({ text: 'Смертей всего:', value: allDeaths })

        const selfStyle = {
            padding: this.trRelateSize(20),
            fontSize: this.trFontSizeSelector('2'),
            column: this.trRelateSize(50)
        }

        return <div className='ngg_caveui_main_blockresults' style={{ ...style, ...selfStyle }}>
            <div className='ngg_caveui_main_blockresults_column' style={{ width: this.trRelateSize(450), rowGap: this.trRelateSize(5) }}>
                {allStatsBlock.map(({ text, value }, index) => {
                    return <div key={`ncmbl_${index}`} className='ngg_caveui_main_blockresults_row' style={{ width: this.trRelateSize(450) }}>
                        <div className='ngg_caveui_main_blockresults_row_clmn' style={{ width: this.trRelateSize(250) }}>{text}</div>
                        <div className='ngg_caveui_main_blockresults_row_clmn' style={{ width: this.trRelateSize(80) }}>{value}</div>
                    </div>
                })}
            </div>
            <div className='ngg_caveui_main_blockresults_column' style={{ width: this.trRelateSize(450), rowGap: this.trRelateSize(5) }}>
                {allStatsCave.map(({ text, value }, index) => {
                    return <div key={`ncmbr_${index}`} className='ngg_caveui_main_blockresults_row' style={{ width: this.trRelateSize(450) }}>
                        <div className='ngg_caveui_main_blockresults_row_clmn' style={{ width: this.trRelateSize(250) }}>{text}</div>
                        <div className='ngg_caveui_main_blockresults_row_clmn' style={{ width: this.trRelateSize(80) }}>{value}</div>
                    </div>
                })}
            </div>
        </div>
    }

    ExtrasCave = ({ style }) => {
        const { caveSession } = this.props;

        const { extras, extrasSlots } = caveSession.person
        //setPlayerExtras

        if (!extrasSlots) return null;

        const extraWidth = this.trRelateSize(96.19);
        const margin = this.trRelateSize(11.67);

        const topMargin = this.trRelateSize(18.57);
        const leftMargin = this.trRelateSize(17.15);

        return <div className='ngg_caveui_main_structure' style={style}>
            {extras.map((extra, index) => {
                const { id, inCave } = extra;
                let background = 'none';
                if (index < extrasSlots) background = `#E6E6E6`;

                return <ExtraSquere key={id}
                    onClick={() => { this.selectExtraItem(index) }}
                    extra={extra}
                    width={extraWidth}
                    top={topMargin}
                    left={leftMargin + (index * (extraWidth + margin))}
                    background={background || 'none'}
                    borderRadius={this.trRelateSize(11)}
                    marker={!!inCave ? 'orange' : ''}
                />

            })}
        </div>
    }

    Lut = ({ style }) => {
        const { caveSession } = this.props;
        const { props } = caveSession;
        const { history } = props;
        const lastHistory = history[history.length - 1];
        const { newItems, newMoney, ExpValue } = lastHistory;

        const items = newItems;

        const extraWidth = this.trRelateSize(96.19);
        const margin = this.trRelateSize(11.67);

        const topMargin = this.trRelateSize(18.57);
        const leftMargin = this.trRelateSize(17.15);

        return <div className='ngg_caveui_main_structure' style={style}>
            {items.map((item, index) => {
                const { id, type, lvl, grade, settings, inCave, isRare, specIcon, desctructed } = item;
                let background = `#E6E6E6`;

                if (type !== 'extra') return null;

                const extra = {
                    id,
                    lvl,
                    grade,
                    inCave,
                    desctructed,
                    specIcon,
                    ...settings,
                }

                return <ExtraSquere key={id}
                    onClick={() => { }}
                    extra={extra}
                    width={extraWidth}
                    top={topMargin}
                    left={leftMargin + (index * (extraWidth + margin))}
                    background={background || 'none'}
                    borderRadius={this.trRelateSize(11)}
                    className={isRare ? '__rare_lut' : ''}
                />

            })}
            {
                !!ExpValue && <ExtraSquere
                    onClick={() => { }}
                    extra={{ type: 'exp', lvl: 1, id: `exp_id` }}
                    width={extraWidth}
                    top={topMargin}
                    left={leftMargin + (items.length * (extraWidth + margin))}
                    background={`#FFFFFF`}
                    borderRadius={this.trRelateSize(11)}
                    count={ExpValue}
                />
            }
            {newMoney.map((money, index) => {
                const { label, count, isRare } = money;
                return <ExtraSquere
                    onClick={() => { }}
                    extra={{ type: 'money', money: label, id: `${label}_${count}` }}
                    width={extraWidth}
                    top={topMargin}
                    left={leftMargin + (items.length * (extraWidth + margin) + ((index + 1) * (extraWidth + margin)))}
                    background={`#FFFFFF`}
                    borderRadius={this.trRelateSize(11)}
                    count={count}
                    className={isRare ? '__rare_lut' : ''}
                />

            })}
        </div>
    }

    // инвентарь при выборе экстров
    ExtrasItems = ({ style }) => {

        const { CaveText } = this;

        let rowNow = 0;
        let nowIndex = -1;
        let maxInRow = 5;

        const extraWidth = this.trRelateSize(96.19);
        const margin = this.trRelateSize(11.67);

        const topMargin = this.trRelateSize(18.57);
        const leftMargin = this.trRelateSize(17.15);

        const { caveSession } = this.props;
        const { items, extras } = caveSession.person;

        const { selectExtraIdInChest } = this;

        const { selectedExtraItem, selectedExtraIdInChest } = this.state;
        const extraSelectedInBar = extras[selectedExtraItem];
        let selectedItemInBarId;
        let selectedItemInBar = items.find(x => x.id === extraSelectedInBar.id); // какой id у предмета в ячейке, на которую мы нажали
        if (selectedItemInBar) selectedItemInBarId = selectedItemInBar.id;

        let selectedItemInChest = null;
        if (selectedExtraIdInChest)
            selectedItemInChest = items.find(x => x.id === selectedExtraIdInChest); // какой id у предмета в сундуке, который мы выбираем


        let buttonStyle = {
            top: this.trRelateSize(440),
            left: this.trRelateSize(674),
            width: this.trRelateSize(221),
            height: this.trRelateSize(64),
            fontSize: `${this.trFontSizeSelector('2')}px`,
            lineHeight: `${this.trFontSizeSelector('2') * 0.8}px`
        }

        let infoStyle = {
            left: this.trRelateSize(585),
            width: this.trRelateSize(365),

            top: '0px',
            height: '100%'
        }

        let ItemComponent = null;

        if (selectedItemInChest) {
            const { specIcon, settings, itemClass } = selectedItemInChest;

            const extraClass = ITEMSCLASSES[itemClass];

            if (!extraClass || !settings) {
                ItemComponent = <div className='ngg_caveui_main_extrasitems_info'>НЕИЗВЕСТНЫЙ ТИП</div>
            } else {

                const { name, discription } = extraClass;

                const label = itemColorLabel(selectedItemInChest);
                let InnerLabel = null;
                if (label && label.color) {
                    const labelWidth = this.trRelateSize(18);
                    InnerLabel = <Fragment>
                        <div style={{
                            background: label.color,
                            width: labelWidth, height: labelWidth, borderRadius: labelWidth / 4
                        }} />
                        <span style={{ fontSize: this.trFontSizeSelector('5') }}>
                            {label.text}
                        </span>
                    </Fragment>
                }
                const { type } = settings;
                let imgSrc = `/../images/ver2/snowman/extras/${specIcon || type}.png`;
                ItemComponent =
                    <div className='ngg_caveui_main_extrasitems_info' style={infoStyle}>
                        <div className='___info_row' style={{ height: this.trRelateSize(42), fontSize: this.trFontSizeSelector('2') }}></div>
                        <div className='___info_row' style={{ height: this.trRelateSize(114) }}>
                            <img src={imgSrc} style={{ width: 'auto', height: this.trRelateSize(105) }} />
                            <div className='___info_row_props' style={{ columnGap: this.trRelateSize(16) }}>
                                {[...ExtraProps({ item: selectedItemInChest, width: this.trRelateSize(36) })]}
                            </div>
                        </div>
                        <div className='___info_row' style={{ height: this.trRelateSize(42), fontSize: this.trFontSizeSelector('1') }}>
                            <span>{name}</span>
                        </div>
                        <div className='___info_row' style={{
                            height: this.trRelateSize(30), fontSize: this.trFontSizeSelector('2'),
                            columnGap: this.trRelateSize(10)
                        }}>
                            {InnerLabel}
                        </div>
                        {/* <div className='___info_row' style={{ height: this.trRelateSize(62), fontSize: this.trFontSizeSelector('2') }}></div> */}
                        <div className='___info_row ___info_row_long' style={{
                            height: this.trRelateSize(208), fontSize: this.trFontSizeSelector('4'),
                            padding: this.trRelateSize(12)
                        }}>
                            <span>{discription}</span>
                        </div>
                    </div>
            }
        }

        return <div className='ngg_caveui_main_extrasitems' style={style}>
            {
                items.map((item) => {
                    if (item.type !== 'extra') return null;
                    const { id, settings, lvl, inCave, grade, specIcon, desctructed } = item;
                    nowIndex++;
                    if (nowIndex >= maxInRow) {
                        nowIndex = 0;
                        rowNow++;
                    }
                    const extra = {
                        id,
                        lvl,
                        grade,
                        specIcon,
                        inCave,
                        desctructed,
                        ...settings,
                    }

                    let className = '';
                    let background = 'none';

                    // смотрим, есть ли этот предмет в экстрах сейчас
                    const isInExtras = extras.find(x => x.id === id);
                    let isSelected = false;
                    let isSelectedInChest = false;
                    if (selectedItemInBarId && id === selectedItemInBarId) {
                        isSelected = true;
                    }
                    if (selectedItemInChest && id === selectedItemInChest.id) {
                        isSelectedInChest = true;
                    }

                    if (isInExtras) {
                        background = `#E6E6E6`;
                    }

                    if (isSelectedInChest) {
                        className = 'ngg_caveui_main_extra_orangegreen';
                    }

                    if (isSelected) {
                        className = 'ngg_caveui_main_extra_bordergreen';
                    }

                    return <ExtraSquere key={id} extra={extra} width={extraWidth}
                        top={topMargin + (rowNow * (extraWidth + margin))}
                        left={leftMargin + (nowIndex * (extraWidth + margin))}
                        borderRadius={this.trRelateSize(11)}
                        onClick={() => { selectExtraIdInChest(id) }}
                        className={className}
                        background={background}
                    />
                })
            }

            <CaveText trFontSize='1' className='ngg_caveui_main_extrasitems_close'
                absolute
                style={{}}
                onClick={() => this.selectExtraItem(null)} >X</CaveText>

            {ItemComponent}
            {
                !!selectedItemInChest && (
                    (selectedItemInBarId === selectedItemInChest.id) ?
                        <div onClick={() => { this.setNewExtras('delete', selectedItemInChest) }} className='ngg_caveui_main_extrasitems_button ngg_caveui_main_extrasitems_buttonred' style={buttonStyle}>
                            <span>УБРАТЬ</span>
                        </div>
                        :
                        <div onClick={() => { this.setNewExtras('add', selectedItemInChest) }} className='ngg_caveui_main_extrasitems_button ngg_caveui_main_extrasitems_buttongreen' style={buttonStyle}>
                            <span>ПОСТАВИТЬ</span>
                        </div>
                )
            }


        </div >
    }

    chooseBlock = (choosedBlock = null) => {
        this.setState({ choosedBlock })
    }

    ChoosedBlockModal = () => {
        const { choosedBlock } = this.state;
        if (!choosedBlock) return null;

        let res = [];

        if (choosedBlock.conditions) {
            if (choosedBlock.conditions.darkness) {
                res.push(<div>{`Темпона Lvl: ${choosedBlock.conditions.darkness.lvl}`}</div>)
            }
            if (choosedBlock.conditions.cold) {
                res.push(<div>{`Холод Lvl: ${choosedBlock.conditions.cold.lvl}`}</div>)
                res.push(<div>{`Холод dpl: ${choosedBlock.conditions.cold.dpl}`}</div>)
            }
        }

        return <Modal
            className='ngg_caveui_main_modal_container'
            visible={true}
            footer={null}
            onCancel={() => this.chooseBlock()}
            closable={true}
        >
            <div className='ngg_caveui_main_modal_container_inner'>
                {res}
                <Button onClick={() => {
                    this.chooseBlock();
                    this.props.onBlockClick(choosedBlock.id);
                }}> ПОГНАЛИ </Button>
            </div>
        </Modal>

    }

    // это один блок
    OneBlock = ({ block }) => {
        const { caveSession } = this.props;
        const { props, cave: { id: caveId } } = caveSession;
        const { passed = {}, nowBlockExp = [] } = props;

        const blockWidth = this.trRelateSize(142.5);
        const blockHeight = this.trRelateSize(83.5);
        const margin = this.trRelateSize(30);

        const topMargin = this.trRelateSize(53.72);
        const leftMargin = this.trRelateSize(98.3);

        const topHeight = this.trRelateSize(61.38);
        const bottomHeight = blockHeight - topHeight;
        const imgHeight = this.trRelateSize(49, 3);

        const { id, enterFrom, endRound, x, y, expAll = 0.01 } = block;
        const findedPass = nowBlockExp.find(x => x.Discription === `Cave_${caveId}_${id}`);
        const expNow = findedPass ? findedPass.Amount : 0;
        // прохождение
        const barWidth = blockWidth * 0.8;
        const percent = expNow / expAll;
        const barFilledWidth = barWidth * percent;
        const barHeight = blockHeight * 0.07;

        let style = {
            width: blockWidth, height: blockHeight,
            top: topMargin + (y * (blockHeight + margin)),
            left: leftMargin + (x * (blockWidth + margin)),
            borderRadius: this.trRelateSize(11)
        }
        let className = 'ngg_caveui_main_structure_block';
        let mayGo = !enterFrom || passed[enterFrom]

        if (!mayGo) className += ' ngg_caveui_main_structure_block_disabled';

        let imgSrc = '/../images/ver2/snowman/ui/cave';
        if (endRound) imgSrc += '_flag';
        if (mayGo) imgSrc += '_full.png'; else imgSrc += '_clean.png';

        return <div key={`nggcb_${id}`} className={className} style={style}
            onClick={() => {
                if (!mayGo) {
                    message.warn('Нельзя пройти');
                    return;
                }
                this.chooseBlock(block);
                //this.props.onBlockClick(id);
            }}
        >
            <div className='ngg_caveui_main_structure_block_top' style={{ height: topHeight }}>
                <img src={imgSrc} style={{ width: 'auto', height: imgHeight }} />
            </div>
            <div className='ngg_caveui_main_structure_block_bottom' style={{ height: bottomHeight }}>
                <div className='ngg_caveui_main_structure_block_bottom_allbar' style={{ width: barWidth, height: barHeight }}>
                    <div className='ngg_caveui_main_structure_block_bottom_filledBar' style={{ width: barFilledWidth }}>
                    </div>
                </div>
            </div>
        </div >
    }

}

const itemColorLabel = (item = {}) => {
    let res = { color: 'black', text: '' };
    const { inCave, desctructed } = item;
    if (isEmpty(item)) return res;

    if (!inCave && !desctructed) {
        res.color = '#00000000';
        res.text = 'Внешний';
    }
    if (!inCave && desctructed) {
        res.color = '#009912';
        res.text = 'Внешний одноразовый';
    }
    if (inCave && !desctructed) {
        res.color = '#FF6600';
        res.text = 'Внутренний';
    }
    if (inCave && desctructed) {
        res.color = '#910707';
        res.text = 'Внутренний одноразовый';
    }
    return res;
}

const ExtraSquere = ({ extra, width, top, left, background, marker, count, borderRadius, className = '', onClick = () => { } }) => {
    const { type, lvl, grade, money, id, specIcon } = extra;
    const style = {
        width: width, height: width,
        top,
        left,
        borderRadius
    }

    const imgHeight = width * 0.7;
    if (background) style.background = background;

    let imgSrc = `/../images/ver2/snowman/extras/${specIcon || type}.png`;

    if (type === 'money') {
        imgSrc = `/../images/ver2/scores/money/${money}.png`;
    }

    let markerColor;
    if (lvl) {
        const info = itemColorLabel(extra)
        if (info.color)
            markerColor = info.color;
    }


    let gradeColor;
    let gradeText = '';
    if (lvl) {
        if (lvl === 1) { gradeText = 'I' }
        if (lvl === 2) { gradeText = 'II' }
        if (lvl === 3) { gradeText = 'III' }
        if (lvl === 4) { gradeText = 'IV' }
        if (lvl === 5) { gradeText = 'V' }

        if (!grade || grade === 1) { gradeColor = `#666666` }
        if (grade === 2) { gradeColor = `#043766` }
        if (grade === 3) { gradeColor = `#69008C` }
        if (grade === 4) { gradeColor = `#B50000` }
        if (grade === 5) { gradeColor = `#CCB102` }
    }

    return <div onClick={onClick} key={id} className={'ngg_caveui_main_extra ' + className} style={style}>
        <img src={imgSrc} style={{ width: 'auto', height: imgHeight }} />
        {!!gradeColor && <div className='ngg_caveui_main_extra_upper' style={{
            background: gradeColor,
            top: width * 0.05, left: width * 0.2, width: width * 0.2, height: width * 0.2, borderRadius: width * 0.05,
            border: `1px solid white`,
            fontSize: width * 0.12
        }} > <span>{gradeText}</span> </div>}
        {!!markerColor && <div className='ngg_caveui_main_extra_upper' style={{
            background: markerColor,
            top: width * 0.05, left: width * 0.9, width: width * 0.2, height: width * 0.2, borderRadius: width * 0.05
        }} />}
        {!!count && <div className='ngg_caveui_main_extra_downer' style={{
            top: width * 0.75, left: width * 0.9, height: width * 0.2, fontSize: width * 0.19
        }} >
            {count}
        </div>
        }
    </div>
}

// штука для пропсов экстра, выдаёт массив div-ов

const parseExtraProps = (settings = {}) => {

    if (isEmpty(settings)) return [];

    //hitBuffs
    //resultBuff
    //passiveBuff

    const processBuf = (inner, keyNow) => {
        let res = [];
        let adder = '';

        if (!inner || isEmpty(inner)) return [];

        if (keyNow === 'resultBuff') {
            adder = 'result_';
        }
        if (keyNow === 'passiveBuff') {
            adder = 'passive_';
        }

        const keys = Object.keys(inner);

        for (let i = 0; i < keys.length; i++) {
            const key = `${adder}${keys[i]}`;

            if (key === 'resultBuff') {
                const dubRes = processBuf(inner[keys[i]], 'resultBuff');
                res = [...res, ...dubRes];
                continue;
            }
            if (key === 'passiveBuff') {
                const dubRes = processBuf(inner[keys[i]], 'passiveBuff');
                res = [...res, ...dubRes];
                continue;
            }
            if (key === 'hitBuffs') {
                let dubRes = [];
                dubRes.push(...processBuf(inner[keys[i]][1], ''));
                dubRes.push(...processBuf(inner[keys[i]][2], ''));
                dubRes.push(...processBuf(inner[keys[i]][3], ''));
                res = [...res, ...dubRes];
            }

            if (key === 'innerLeft' && inner[keys[i]] === 1) {
                continue;
            }

            if (EXTRASPARAMS[key]) {
                const { label, adderText = '' } = EXTRASPARAMS[key];
                res.push({
                    key,
                    value: inner[keys[i]] + adderText,
                    title: label
                })
            } else if (EXTRASPARAMS[keys[i]]) {
                const { label, adderText = '' } = EXTRASPARAMS[keys[i]];
                res.push({
                    key: keys[i],
                    value: inner[keys[i]] + adderText,
                    title: label
                })
            }
        }

        return res;

    }

    return processBuf(settings, 'settings')

}

const ExtraProps = ({ item, width }) => {
    const { settings, name } = item;

    let propses = parseExtraProps(settings); // { key, value, title }
    let res = [];

    for (let i = 0; i < propses.length; i++) {
        const { key, value, title } = propses[i];

        res.push(<div title={title} id={key + name + i} key={key + name + i} className='nggame_cave_props' style={{ width, fontSize: width * 0.5, rowGap: width * 0.17 }}>
            <img src={`/../images/ver2/snowman/extras/props/${key}.png`} />
            <span>{value}</span>
        </div>)

    }

    return res;
}